import { __extends } from "tslib";

import { DepthRenderer } from "../Rendering/depthRenderer.js";
import { MinMaxReducer } from "./minMaxReducer.js";
/**
 * This class is a small wrapper around the MinMaxReducer class to compute the min/max values of a depth texture
 */
var DepthReducer = /** @class */ (function (_super) {
    __extends(DepthReducer, _super);
    /**
     * Creates a depth reducer
     * @param camera The camera used to render the depth texture
     */
    function DepthReducer(camera) {
        return _super.call(this, camera) || this;
    }
    Object.defineProperty(DepthReducer.prototype, "depthRenderer", {
        /**
         * Gets the depth renderer used for the computation.
         * Note that the result is null if you provide your own renderer when calling setDepthRenderer.
         */
        get: function () {
            return this._depthRenderer;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Sets the depth renderer to use to generate the depth map
     * @param depthRenderer The depth renderer to use. If not provided, a new one will be created automatically
     * @param type The texture type of the depth map (default: TEXTURETYPE_HALF_FLOAT)
     * @param forceFullscreenViewport Forces the post processes used for the reduction to be applied without taking into account viewport (defaults to true)
     */
    DepthReducer.prototype.setDepthRenderer = function (depthRenderer, type, forceFullscreenViewport) {
        if (depthRenderer === void 0) { depthRenderer = null; }
        if (type === void 0) { type = 2; }
        if (forceFullscreenViewport === void 0) { forceFullscreenViewport = true; }
        var scene = this._camera.getScene();
        if (this._depthRenderer) {
            delete scene._depthRenderer[this._depthRendererId];
            this._depthRenderer.dispose();
            this._depthRenderer = null;
        }
        if (depthRenderer === null) {
            if (!scene._depthRenderer) {
                scene._depthRenderer = {};
            }
            depthRenderer = this._depthRenderer = new DepthRenderer(scene, type, this._camera, false, 1);
            depthRenderer.enabled = false;
            this._depthRendererId = "minmax" + this._camera.id;
            scene._depthRenderer[this._depthRendererId] = depthRenderer;
        }
        _super.prototype.setSourceTexture.call(this, depthRenderer.getDepthMap(), true, type, forceFullscreenViewport);
    };
    /**
     * @param sourceTexture
     * @param depthRedux
     * @param type
     * @param forceFullscreenViewport
     * @hidden
     */
    DepthReducer.prototype.setSourceTexture = function (sourceTexture, depthRedux, type, forceFullscreenViewport) {
        if (type === void 0) { type = 2; }
        if (forceFullscreenViewport === void 0) { forceFullscreenViewport = true; }
        _super.prototype.setSourceTexture.call(this, sourceTexture, depthRedux, type, forceFullscreenViewport);
    };
    /**
     * Activates the reduction computation.
     * When activated, the observers registered in onAfterReductionPerformed are
     * called after the computation is performed
     */
    DepthReducer.prototype.activate = function () {
        if (this._depthRenderer) {
            this._depthRenderer.enabled = true;
        }
        _super.prototype.activate.call(this);
    };
    /**
     * Deactivates the reduction computation.
     */
    DepthReducer.prototype.deactivate = function () {
        _super.prototype.deactivate.call(this);
        if (this._depthRenderer) {
            this._depthRenderer.enabled = false;
        }
    };
    /**
     * Disposes the depth reducer
     * @param disposeAll true to dispose all the resources. You should always call this function with true as the parameter (or without any parameter as it is the default one). This flag is meant to be used internally.
     */
    DepthReducer.prototype.dispose = function (disposeAll) {
        if (disposeAll === void 0) { disposeAll = true; }
        _super.prototype.dispose.call(this, disposeAll);
        if (this._depthRenderer && disposeAll) {
            var scene = this._depthRenderer.getDepthMap().getScene();
            if (scene) {
                delete scene._depthRenderer[this._depthRendererId];
            }
            this._depthRenderer.dispose();
            this._depthRenderer = null;
        }
    };
    return DepthReducer;
}(MinMaxReducer));
export { DepthReducer };
//# sourceMappingURL=depthReducer.js.map